let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GG2O")).then(() => parcelRequire('aDQEH'));